import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import KeepAliveHandler from '@/Management/KeepAliveHandler';
import * as CoreFrameDtOs from "coreframetypings/dto";
import RADApplication from '@/Management/RADApplication';
import * as DownloadHelper from '@/Utility/DownloadHelper';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import Utilities from '@/Utility/Utilities';

export default class PDMetadataTransferUIListener extends UIListener {
    private static ExportierenMethod = 'Export';
    private static ImportierenMethod = 'Import';
    private static File_Filename = 'File.Filename';
    private isImportInvoked = false;

    constructor() {
        super();
    }

    /**
    * @override
    */
    public onDetailViewReady(context: DetailViewContext): void {
        this.updateFile(context);
    }

    /**
    * @override
    */
    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        if (property === PDMetadataTransferUIListener.File_Filename) {
            this.updateFile(context);
        }
    }

    private updateFile(context: DetailViewContext): void {
        const file = context.genericObject.getValue(PDMetadataTransferUIListener.File_Filename);
        const isEnabled = !Utilities.isNullOrUndefinedOrBlank(file);
        
        const element = context.toolBar.getElementByMethodName(PDMetadataTransferUIListener.ImportierenMethod);
        element?.isEnabled(isEnabled);
    }

    /**
    * @override
    */
    public onBeforeApply(context: DetailViewContext): boolean {
        this.isImportInvoked = false;
        return true;
    }

    /**
    * @override
    */
    public onBeforeCallOperation(context: any, operation: string): boolean {
        KeepAliveHandler.getInstance().disableAutoLogout = true;

        if (operation === PDMetadataTransferUIListener.ImportierenMethod)
            this.isImportInvoked = true;

        return true;
    }

    /**
     * @override
     */
    public onAfterCallOperation(context: DetailViewContext, operation: string, args: CoreFrameDtOs.IOperationResultDTO) {
        KeepAliveHandler.getInstance().disableAutoLogout = false;

        if (operation === PDMetadataTransferUIListener.ExportierenMethod) {
            // Verhindert, dass beim Verlassen der Speichern-Dialog geöffnet wird
            // Darf aber nur ausgeführt werden, wenn noch kein Import durchgeführt wurde
            if (!this.isImportInvoked)
                context.apply();

            if (!args.isValid)
                return;

            const messageBox = this.createMessageBox(args);
            RADApplication.getInstance().showMessageBox(messageBox);
        }
        else if (operation == PDMetadataTransferUIListener.ImportierenMethod) {
            if (args.isValid)
                return;

            this.disableView(context);
        }
    }

    private disableView(context: DetailViewContext) {
        const names = ['SAVE', 'APPLY', PDMetadataTransferUIListener.ExportierenMethod, PDMetadataTransferUIListener.ImportierenMethod];

        for (let name of names) {
            context.toolBar.getElementByErgName(name)?.isEnabled(false);
            context.toolBar.getElementByMethodName(name)?.isEnabled(false);
        }

        context.genericObject.isModified(false);
    }

    private createMessageBox(result: CoreFrameDtOs.IOperationResultDTO): any {
        let caption = null;
        let customParams = {
            window: { headline: { ergName: "RAD.RADFOUNDATION.PROBLEMDOMAIN.META.TRANSFER.PDMETADATATRANSFER_EXPORT_SUCCESS_TITLE" } },
            button: { label: { ergName: 'DOWNLOAD' } }
        };

        let callback = () => DownloadHelper.openDownloadDialogFromApplicationAsync(result.returnValue);
        return MessageBoxViewModel.createCustomNoticeMessageBox(caption,
            "RAD.RADFOUNDATION.PROBLEMDOMAIN.META.TRANSFER.PDMETADATATRANSFER_EXPORT_SUCCESS_MESSAGE", customParams, callback);
    }
}

ComponentManager.setUIListener('PDMetadataTransferUIListener', PDMetadataTransferUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.PDMetadataTransferUIListener', PDMetadataTransferUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');